import React, { useState, useEffect } from "react";
import {
  DialogContent,
  TextField,
  InputLabel,
  Grid,
  FormControl,
  Select,
  MenuItem,
  Button,
  Typography,
} from "@mui/material";
import promoStyle from "./style";
import BootstrapDialog from "../../../../components/dialog";
import DialogHeader from "../../../../components/dialog/dialogHeader";
import DialogFooter from "../../../../components/dialog/dialogFooter";
import ImageUploader from "../../../../components/imageUploader";
import { primaryColor } from "../../../../constants/colors";

export default function RestaurentDialog({
  open,
  type,
  handleClose,
  inputValue,
  setInputValue,
  image,
  setImage,
  category,
  setCategory,
  setStatus,
  status,
}) {
  const classes = promoStyle();

  const handleChangeInput = (e) => {
    setInputValue({
      ...inputValue,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeCategory = (e) => {
    setCategory(e.target.value);
  };

  const handleBtn = () => {
    // let { name, price, quantity, description, discount } = inputValue;
    // let params = {
    //   name,
    //   image,
    //   price,
    //   description,
    //   category: categoryValue,
    //   discount,
    //   quantity,
    //   storeId: userData._id,
    // };
    // let idParams = {
    //   userId: userData._id,
    //   productId: dialogData?._id,
    // };
    // if (
    //   name == "" ||
    //   price == "" ||
    //   quantity == "" ||
    //   description == "" ||
    //   discount == ""
    // ) {
    //   setSnackbarProps({
    //     open: true,
    //     type: "error",
    //     message: "All fields are required",
    //   });
    // } else if (image == null) {
    //   setSnackbarProps({
    //     open: true,
    //     type: "error",
    //     message: "Image is required",
    //   });
    // } else if (categoryValue == "") {
    //   setSnackbarProps({
    //     open: true,
    //     type: "error",
    //     message: "Please create a category first",
    //   });
    // } else if (type === "add") {
    //   createProduct(params, userData._id);
    //   handleClose();
    // } else {
    //   updateProduct(params, idParams);
    //   handleClose();
    // }
  };

  const handleStatus = () => {
    setStatus(!status);
  };

  console.log(type, "typetypetype");

  const handleCloseSnackbar = () => {};

  const catData = [
    {
      name: "Desi Food",
    },
    {
      name: "Fast Food",
    },
  ];

  return (
    <div>
      <BootstrapDialog onClose={handleClose} open={open}>
        <DialogHeader
          title={type == "add" ? "Add Restaurant" : "Edit Restaurant"}
          handleClose={handleClose}
        />
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} marginTop='12px'>
              <div>
                <ImageUploader
                  type='profile'
                  image={image}
                  setImage={setImage}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6}>
              <InputLabel className={classes.globalInputLabel}>Name</InputLabel>
              <TextField
                placeholder='Name'
                variant='outlined'
                size='small'
                name='name'
                className={classes.globalInput}
                value={inputValue.name}
                onChange={handleChangeInput}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <InputLabel className={classes.globalInputLabel}>
                Email
              </InputLabel>
              <TextField
                placeholder='Email'
                variant='outlined'
                size='small'
                className={classes.globalInput}
                name='email'
                type='email'
                value={inputValue.email}
                onChange={handleChangeInput}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <InputLabel className={classes.globalInputLabel}>
                Phone Number
              </InputLabel>
              <TextField
                placeholder='Phone Number'
                variant='outlined'
                type='number'
                size='small'
                className={classes.globalInput}
                name='phoneNumber'
                value={inputValue.phoneNumber}
                onChange={handleChangeInput}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <InputLabel className={classes.globalInputLabel}>
                Address
              </InputLabel>
              <TextField
                placeholder='Address'
                variant='outlined'
                type='text'
                size='small'
                className={classes.globalInput}
                name='address'
                value={inputValue.address}
                onChange={handleChangeInput}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <InputLabel htmlFor='fName' className={classes.globalInputLabel}>
                Category
              </InputLabel>
              <FormControl
                variant='outlined'
                className={classes.globalSelectStyle}
                style={{ textAlign: "left" }}
              >
                <Select
                  displayEmpty
                  value={category}
                  onChange={handleChangeCategory}
                >
                  <MenuItem disabled value='' style={{ fontSize: "12px" }}>
                    Select Category
                  </MenuItem>
                  {catData.map((item) => {
                    return (
                      <MenuItem value={item.name} style={{ fontSize: "12px" }}>
                        {item.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <div style={{ margin: "10px 0" }}>
            <Typography style={{ fontWeight: "600" }}>
              Status:{" "}
              <span style={{ fontWeight: "500" }}>{inputValue.status}</span>
            </Typography>
          </div>
          <Grid container spacing={1} marginTop={2}>
            <Grid item xs={12} md={3}>
              <Button
                variant='contained'
                className={classes.loginBtn}
                size='small'
                // onClick={handleLogin}
                disableRipple
                style={{ backgroundColor: status ? primaryColor : "red" }}
              >
                <Typography className={classes.loginBtnText}>
                  {status ? "Remove" : "Reject"}
                </Typography>
              </Button>
            </Grid>
            <Grid item xs={12} md={3}>
              <Button
                variant='contained'
                className={classes.loginBtn}
                size='small'
                onClick={handleStatus}
                disableRipple
                style={{ backgroundColor: status ? primaryColor : "green" }}
              >
                <Typography className={classes.loginBtnText}>
                  {status ? "Deactivate" : "Accept"}
                </Typography>
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogFooter
          type={type}
          handleCreate={handleBtn}
          handleUpdate={handleBtn}
          handleClose={handleClose}
        />
      </BootstrapDialog>
    </div>
  );
}
